module.exports = __webpack_public_path__ + "img/1.886c7b17.png";